export default {"src":"/_next/static/media/0x4af15ec2a0bd43db75dd04e62faa3b8ef36b00d5.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};